import { useQuery } from '@tanstack/react-query'
import { api } from '@api'

export interface MergeSuggestionProfile {
  id?: string
  accountId?: string
  firstName: string
  lastName: string
  fullName: string
  avatarUrl: string
  hashtags: string[]
}

export type MergeMatchReason =
  | 'FullName'
  | 'LastName'
  | 'FirstName'
  | 'Email'
  | 'Phone'
  | 'LinkedIn'
  | 'Instagram'
  | 'Facebook'
  | 'Twitter'

export interface MergeSuggestion {
  ghostProfile: MergeSuggestionProfile & { id: string }
  realContact: MergeSuggestionProfile & { accountId: string }
  matchScore: number
  matchReasons: MergeMatchReason[]
}

interface MergeSuggestionsResponse {
  suggestions: MergeSuggestion[]
}

const fetchMergeSuggestions = async (): Promise<MergeSuggestion[]> => {
  const { data } = await api.get<MergeSuggestionsResponse>('/ft_merge-suggestions')
  return data.suggestions
}

export const useFtMergeSuggestions = () => {
  return useQuery<MergeSuggestion[]>({
    queryKey: ['ft-merge-suggestions'],
    queryFn: fetchMergeSuggestions,
  })
}
